import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Precanned from './Precanned';
import { addPrecanned, editPrecanned, deletePrecanned } from '../redux/FeedbackRedux';
import Bar from "./Bar";

class ChatSettingsPrecanned extends React.Component {
    handleTextChange(uuid, event) {
        this.props.dispatch(editPrecanned({ uuid: uuid, text: event.target.value, type: 'text' }));
    }

    handleLabelChange(uuid, event) {
        this.props.dispatch(editPrecanned({ uuid: uuid, text: event.target.value, type: 'label' }));
    }

    handleClick(event) {
        event.preventDefault();
        this.props.dispatch(addPrecanned());
    }

    handleSubmit(event) {
        event.preventDefault();
        var valid = true;
        var precannedSettings = this;
        var temp_array = [];
        this.props.state.precanned.forEach(function (value, index) {
            if (value.label == "") {
                valid = false;
                precannedSettings.props.dispatch(editPrecanned({ uuid: value.uuid, text: __('Please enter a label.'), type: 'label_error' }));
            }
            else {
                precannedSettings.props.dispatch(editPrecanned({ uuid: value.uuid, text: false, type: 'label_error' }));
            }
            if (value.text == "") {
                valid = false;
                precannedSettings.props.dispatch(editPrecanned({ uuid: value.uuid, text: __('Please enter a message.'), type: 'text_error' }));
            }
            else {
                precannedSettings.props.dispatch(editPrecanned({ uuid: value.uuid, text: false, type: 'text_error' }));
            }
            temp_array.push(value.label);
        });

        var duplicateElementa = temp_array.filter((item, index) => temp_array.indexOf(item) !== index);

        if (valid) {
            if (duplicateElementa.length === 0)
                document.getElementById('chatSettingsPrecannedForm').submit();
            else {
                duplicateElementa.forEach(function (label) {
                    var index = temp_array.indexOf(label, temp_array.length - 1);
                    var value = precannedSettings.props.state.precanned[index];
                    precannedSettings.props.dispatch(editPrecanned({ uuid: value.uuid, text: __('Please enter the non-duplicated label.'), type: 'label_error' }));
                })
            }
        }
        else {

        }

        // this.props.dispatch(addPrecanned());
    }

    handleDelete(uuid, event) {
        event.preventDefault();
        this.props.dispatch(deletePrecanned({ uuid: uuid }));
    }



    render() {
        return (
            <form className="tags-form" method="post"
                onSubmit={this.handleSubmit.bind(this)}
                id="chatSettingsPrecannedForm"
                action={"/business/" + this.props.state.business.business_id + "/chat-settings/precanned/post"}
            >
                <input type="hidden" name="_token" className="makecsrf" />
                <Bar middleCenter mobileColumn>
                    <p className='mb-0 w-100 mx-3'>{__('On this page you can add/edit/delete the pre-canned chat messages that will allow you to quickly respond to Feedbackers in chat conversations.')}</p>
                    <span className='text-primary mr-2 flex-shrink-0 save-change-alert mt-1 ml-auto'>{__('Changes Made, Please Save The Changes')}</span>
                    <button className='btn btn-primary text-nowrap mt-1 ml-auto' type='submit'>
                        <i className='fas fa-save mr-1' />
                        {__('Save Changes')}
                    </button>
                </Bar>

                <div className='p-2'>
                    <div className='card'>
                        <div className='title d-flex align-items-center px-3 py-2'>
                            <h4 className='mb-0'>{__('Canned Responses')}</h4>
                            <button className='btn btn-primary ml-5' onClick={this.handleClick.bind(this)} type="button">
                                <i className='fas fa-plus-circle mr-1' /> {__('Add Canned Response')}
                            </button>
                        </div>
                        <div className='card-body'>
                            {[...this.props.state.precanned].sort((item1, item2) => {
                                if (item1.id == null) return -1;
                                if (item2.id == null) return 1;
                                return new Date(item2.creation_date) - new Date(item1.creation_date);
                            }).map((value, index) => {
                                return (
                                    <Precanned key={value.uuid} precanned={value} uuid={value.uuid} delete={this.handleDelete.bind(this, value.uuid)} changeLabel={this.handleLabelChange.bind(this, value.uuid)} changeText={this.handleTextChange.bind(this, value.uuid)} />
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-center mb-3">
                    <button className='btn btn-primary text-nowrap' type='submit'>
                        <i className='fas fa-save mr-1' />
                        {__('Save Changes')}
                    </button>
                </div>
            </form>
        );
    }
}

function mapStateToProps(state) {
    return { state: state }
}

export default connect(mapStateToProps)(ChatSettingsPrecanned);
